import React from 'react';
import { Router } from 'react-router-dom';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { createBrowserHistory } from 'history';
import CssBaseline from '@material-ui/core/CssBaseline';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { APP_NAME, lang } from 'utils/constants';
import { getDateFnsLocale } from 'utils/date';
import { routerStore, syncHistoryWithStore } from 'stores';
import { ScrollToTop } from 'components';
import useStyles from './App.styles';
import Routes from './routes';
import theme from './theme';
import { initSentry } from './utils';

initSentry();

const browserHistory = createBrowserHistory({
  basename: `/${APP_NAME}/`,
});
const history = syncHistoryWithStore(browserHistory, routerStore);

const App = () => {
  useStyles();

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      <Router history={history}>
        <ScrollToTop />
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={getDateFnsLocale(lang)}>
          <Routes />
        </MuiPickersUtilsProvider>
      </Router>
    </MuiThemeProvider>
  );
};

export default App;
